import { memo, useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";
import { MILAN_CENTER, placeOf } from "../lib/constants";

const wydIcon = L.divIcon({
  className: "",
  html: '<div class="wyd-marker"></div>',
  iconSize: [18, 18],
  iconAnchor: [9, 9],
});

const userIcon = L.divIcon({
  className: "",
  html: '<div style="width:16px;height:16px;border-radius:50%;background:#F7A068;border:3px solid #F5F0E8;box-shadow:0 0 0 4px rgba(247,160,104,0.25)"></div>',
  iconSize: [16, 16], iconAnchor: [8, 8],
});

const EventMarker = memo(({ e }) => {
  const position = useMemo(() => [e.latitude, e.longitude], [e.latitude, e.longitude]);
  return (
    <Marker position={position} icon={wydIcon}>
      <Popup>
        <div style={{ minWidth: 160 }}>
          <div className="font-display font-bold" style={{ fontSize: 15, marginBottom: 4 }}>{e.title}</div>
          <div style={{ fontSize: 12, color: "rgba(245,240,232,0.7)" }}>{[e.category, placeOf(e)].filter(Boolean).join(" · ")}</div>
          {e.recurrence_label && <div style={{ fontSize: 12, color: "#B79CFF" }}>{e.recurrence_label}{e.time ? ` alle ${e.time}` : ""}</div>}
          {e.address && <div style={{ fontSize: 12, color: "rgba(245,240,232,0.7)" }}>{e.address}</div>}
          <Link to={`/evento/${e.id}`} style={{ fontSize: 13, fontWeight: 600 }}>Dettagli →</Link>
        </div>
      </Popup>
    </Marker>
  );
});

export const MapView = ({ events = [], center = MILAN_CENTER, zoom = 13, userPos = null, height = "70vh" }) => {
  const located = useMemo(() => events.filter((e) => e.latitude && e.longitude), [events]);
  return (
    <div className="rounded-2xl overflow-hidden border border-white/10" style={{ height }} data-testid="map-container">
      <MapContainer center={center} zoom={zoom} style={{ height: "100%", width: "100%" }} scrollWheelZoom={true}>
        <TileLayer
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        />
        {located.map((e) => <EventMarker key={e.id} e={e} />)}
        {userPos && (
          <Marker position={userPos} icon={userIcon}>
            <Popup>Sei qui</Popup>
          </Marker>
        )}
      </MapContainer>
    </div>
  );
};
